export default {
    projectName: 'PAGONI',
    logo: '',
    maxImageSize: 2000,
    tokenTypeBearer: true, // type of the Auth token is bearer
    API_KEY: 'fsf4f1fasfsdf374re1f',
    ID: 'id', //id or _id
    licenceID: 'string', // the id to take the activated modules,
    image_field_name: 'image', // το ονομα που εχει το πεδιο με τις εικονες στο project
  };